import { EnvironmentUrls } from 'Roblox';
import UrlConfig from '../../../../../../Roblox.CoreScripts.WebApp/Roblox.CoreScripts.WebApp/js/core/http/interfaces/UrlConfig';
import { DismissOption, PromptType, ViewType } from './parameters';

const URL_NOT_FOUND = 'URL_NOT_FOUND';
const authApiUrl = EnvironmentUrls.authApi ?? URL_NOT_FOUND;
const accountSettingsApiUrl = EnvironmentUrls.accountSettingsApi ?? URL_NOT_FOUND;

/*
 * Password
 */

export enum PasswordError {
  FLOODED = 2,
  INVALID_PASSWORD = 7,
  INVALID_CURRENT_PASSWORD = 8,
  PIN_LOCKED = 9
}

export type ChangePasswordReturnType = void;

/**
 * Request Type: `POST`.
 */
export const CHANGE_PASSWORD_CONFIG: UrlConfig = {
  withCredentials: true,
  url: `${authApiUrl}/v2/user/passwords/change`
};

/*
 * Password Reset
 */

export enum PasswordResetError {
  USER_DOES_NOT_HAVE_EMAIL = 22
}

export type ResetSendPromptedReturnType = void;

export const RESET_SEND_PROMPTED_CONFIG: UrlConfig = {
  withCredentials: true,
  url: `${authApiUrl}/v2/passwords/reset/send-prompted`
};

/*
 * Account Pin
 */

export enum AccountPinError {
  NO_ACCOUNT_PIN = 1,
  ACCOUNT_LOCKED = 2,
  FLOODED = 3,
  INCORRECT_PIN = 4
}

export type GetAccountPinStateReturnType = {
  isEnabled: false;
  /** Seconds the account pin is unlocked for. */
  unlockedUntil: number | null;
};

/**
 * Request Type: `GET`.
 */
export const GET_ACCOUNT_PIN_STATE_CONFIG: UrlConfig = {
  withCredentials: true,
  url: `${authApiUrl}/v1/account/pin`
};

export type UnlockAccountPinReturnType = {
  /** Seconds the account pin is unlocked for. */
  unlockedUntil: number;
};

/**
 * Request Type: `POST`.
 */
export const UNLOCK_ACCOUNT_PIN_CONFIG: UrlConfig = {
  withCredentials: true,
  url: `${authApiUrl}/v1/account/pin/unlock`
};

export type LockAccountPinReturnType = {
  success: true;
};

/**
 * Request Type: `POST`.
 */
export const LOCK_ACCOUNT_PIN_CONFIG: UrlConfig = {
  withCredentials: true,
  url: `${authApiUrl}/v1/account/pin/lock`
};

/**
 * Account Email
 */

export enum EmailError {
  FEATURE_DISABLED = 2,
  TOO_MANY_ACCOUNTS_ON_EMAIL = 3,
  TOO_MANY_ATTEMPTS_TO_UPDATE_EMAIL = 6,
  INVALID_EMAIL_ADDRESS = 9
}

export type UpdateEmailReturnType = void;

export const UPDATE_EMAIL_CONFIG: UrlConfig = {
  withCredentials: true,
  url: `${accountSettingsApiUrl}/v1/email`
};

/*
 * Account Security
 */

export enum AccountSecurityError {
  UNKNOWN = 0,
  UNABLE_TO_COLLECT_PARAMETERS = 1,
  RECEIVED_FLAWED_PARAMETERS = 2,
  PARAMETER_COLLECTION_TURNED_OFF = 3
}

export type GetSecurityPromptParametersReturnType =
  | {
      promptType: PromptType;
      viewType: ViewType;
      dismissOption: DismissOption;
      clearLocalPreferences: boolean;
    }
  | {
      promptType: null;
      viewType: null;
      dismissOption: null;
      clearLocalPreferences: boolean;
    };

export const GET_SECURITY_PROMPT_PARAMETERS_CONFIG: UrlConfig = {
  withCredentials: true,
  url: `${authApiUrl}/v1/security-prompt-parameters`
};
